<template>
  <div>
    <div class="card p-4">
      <dataTableVue
        ref="refDataTable"
        :isSearch="false"
        :isFilter="true"
        :isExport="false"
        v-bind:data="{
          columns: columns,
          rows: rows,
          filter_custom: 'filterCustomHistory',
        }"
        @load="loadItems"
        @dataRow="onRowClick"
      />
    </div>
    <b-modal
      size="lg"
      hide-footer
      content-class="rounded-1"
      v-model="show"
      body-class="p-4"
      centered
      title="Mail History"
    >
      <div class="row">
        <div class="col-4 text-center h5">{{ modalData.tracking_id }}</div>
        <div class="col-4 text-center h5">Type: {{ modalData.type }}</div>
        <div class="col-4 text-center h5 mb-4">
          Status: {{ modalData.mail_status }}
        </div>
        <div class="col-8">
          <div v-for="(item, i) in modalForm" :key="i">
            <b-input-group class="mb-2" :prepend="item.prepend">
              <b-form-input
                v-if="item.type !== 'tag'"
                disabled
                v-model="item.value"
              ></b-form-input>
              <vue-tags-input
                v-else
                disabled
                style="flex: 1 1 auto; background: #eaecef"
                :tags="item.tags"
                value=""
                :separators="separators"
                @tags-changed="(newTags) => (item.tags = newTags)"
              ></vue-tags-input>
            </b-input-group>
          </div>
        </div>
        <div class="col-4">
          <div class="d-flex align-items-center" @click="showAttachments">
            <Icon
              icon="fluent:mail-attach-16-regular"
              width="30"
              height="30"
              class="mx-1 icon align-items-center"
            />Attachments
            <span v-if="attachments.length > 0">
              ({{ attachments.length }})</span
            >
          </div>
        </div>
        <div class="col-12">
          <b-input-group prepend="Subject">
            <b-form-input disabled :value="modalData.subject"></b-form-input>
          </b-input-group>
        </div>
        <div v-if="modalData.case_no" class="col-12 mt-2">
          <b-input-group prepend="Case No.">
            <b-form-input disabled :value="`${modalData.case_no} [${modalData.user_name}]`"></b-form-input>
          </b-input-group>
        </div>
        <div class="col-12">
          <p
            class="border rounded p-3 mt-2"
            style="word-break: break-all"
            v-html="mail"
          ></p>
        </div>
      </div>
    </b-modal>
    <b-modal
      ref="modal-history-attachments-file"
      id="modal-history-attachments-file"
      size="xl"
      centered
      title="Attachments"
      hide-footer
      class="theme-modal"
    >
      <div class="file-content">
        <div class="card">
          <div class="card-body file-manager">
            <template v-if="attachments.length > 0">
              <h6>Files</h6>
              <ul class="files">
                <li
                  class="file-box"
                  v-for="(n, index) in attachments"
                  :key="index"
                >
                  <div class="file-top">
                    <i class="fa fa-file-archive-o txt-secondary"></i>
                  </div>
                  <div class="file-bottom">
                    <h6>{{ n.name }}</h6>
                    <p class="mb-1">{{ formatBytes(n.size) }}</p>
                    <p>
                      <a
                        href="javascript:void(0)"
                        @click="
                          downloadFile(
                            n.name,
                            n.contentType,
                            n.contentBytes,
                            n.size,
                            n.from,
                            n.mail_id
                          )
                        "
                        >Download</a
                      >
                    </p>
                  </div>
                </li>
              </ul>
            </template>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import { requestService } from './../../_services';
  import { Icon } from '@iconify/vue2';

  export default {
    components: {
      Icon,
    },
    data() {
      return {
        mail: '',
        modalForm: [
          {
            prepend: 'Date',
            value: '',
          },
          {
            prepend: 'From',
            value: '',
            type: 'tag',
            tags: [],
          },
          {
            prepend: 'To',
            value: [],
            type: 'tag',
            tags: [],
          },
          {
            prepend: 'CC',
            value: [],
            type: 'tag',
            tags: [],
          },
          {
            prepend: 'BCC',
            value: [],
            type: 'tag',
            tags: [],
          },
        ],
        separators: [';', ',', ' ' , '<','>'],
        form: [
          {
            value: '',
            col: 4,
            name: 'Tracking ID',
            type: 'input',
            key: 'tracking',
          },
          {
            value: '',
            col: 4,
            name: 'Type',
            type: 'input',
            key: 'type',
          },
          {
            value: '',
            col: 4,
            name: 'Status',
            type: 'input',
            key: 'status',
          },
          {
            value: '',
            col: 12,
            name: 'From',
            type: 'select',
            key: 'from',
          },
          {
            value: '',
            col: 12,
            name: 'To',
            type: 'select',
            key: 'to',
          },
          {
            value: '',
            col: 12,
            name: 'CC',
            type: 'select',
            key: 'cc',
          },
          {
            value: '',
            col: 12,
            name: 'BCC',
            type: 'select',
            key: 'bcc',
          },
          {
            value: '',
            col: 12,
            name: 'Message',
            type: 'editor',
            key: 'body',
          },
          {
            value: '',
            col: 12,
            name: 'Subject',
            type: 'input',
            key: 'subject',
          },
        ],
        show: false,
        rows: [],
        columns: [
          {
            label: 'Tracking ID',
            field: 'tracking_id',
            hidden: false,
          },
          {
            label: 'Subject',
            field: 'subject',
            hidden: false,
          },
          {
            label: 'Type',
            field: 'mail_type',
            hidden: false,
          },
          {
            label: 'Agent',
            field: 'user_name',
            hidden: false,
          },
          {
            label: 'Data/Time',
            field: 'created_at',
            hidden: false,
          },
          {
            label: 'Status',
            field: 'mail_status',
            hidden: false,
          },
          {
            label: 'Close By',
            field: 'close_by',
            hidden: false,
          },
        ],
        formV: {
          tracking: '',
          type: '',
          status: '',
          to: [],
          bcc: [],
          cc: [],
          subject: '',
          body: '',
        },
        modalData: {},
        attachments: [],
      };
    },
    async mounted() {
      await this.loadItems();
    },
    methods: {
      formatBytes(bytes, decimals = 2) {
        if (!+bytes) return '0 Bytes';
        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${
          sizes[i]
        }`;
      },
      downloadFile(filename, type, base64, size, from, mail_id) {
        if ((from == 'external') || (from == 'inbound')) {

          //avoid no ext or wrong ext (force to use .eml instead)
          var extension = filename.split('.').pop();
          if ((extension.length > 5) || (extension.length ==0)) {
              type = "message/rfc822"
              filename =  filename + ".eml"
          }

          /*const downloadLink = document.createElement('a');
          var file = base64;
          var filename = filename;
          var blob = new Blob([file]);
          var url = URL.createObjectURL(blob);
          downloadLink.href = url;
          downloadLink.download = filename;
          downloadLink.click();*/

          const linkSource = `data:${type};base64,${base64}`;
          const downloadLink = document.createElement("a");
          downloadLink.href = linkSource;
          downloadLink.download = filename;
          downloadLink.click();
        } else {
          let object = {
            id: mail_id,
            from: from,
            contentType: type,
            size: size,
            name: filename,
          };
          let url = `/api/mail/download/file`;
          requestService
            .PostFetch('ccp', url, object)
            .then((response) => response.blob())
            .then((blob) => {
              const link = document.createElement('a');
              link.href = URL.createObjectURL(blob);
              link.download = filename;
              link.click();
            })
            .catch((err) => {
              this.$swal.fire({ icon: 'error', title: 'Try Again', text: err });
            });
        }
      },
      showAttachments() {
        if (this.attachments.length > 0) {
          this.$refs['modal-history-attachments-file'].show();
        }
      },
      getMailDetail(mail_id) {
        let url = `/api/mail/${mail_id}/mail/detail`;

        requestService
          .GetFetch('ccp', url)
          .then((response) => {
            if (response.status == 200) {
              let self = this;
              self.attachments = [];
              response.text().then((text) => {
                const data = text && JSON.parse(text);
                if (data.data != null) {
                  if (data.data.attachments != null) {
                    data.data.attachments.forEach((element) => {
                      element.from = 'inbound';
                      element.mail_id = data.data.mail_id;
                    });
                    self.attachments = data.data.attachments;
                  }
                  self.formV.tracking = data.data.detail.tracking_id;
                  self.formV.type = data.data.detail.type;
                  self.formV.mail_status = data.data.detail.status;
                  self.formV.to = data.data.detail.to_recipients;
                  self.formV.bcc = data.data.detail.bcc_recipients;
                  self.formV.cc = data.data.detail.cc_recipients;
                  self.formV.subject = data.data.detail.subject;
                  self.formV.body = data.data.body;
                }
              });
            }
          })
          .catch((err) => {
            this.$swal.fire({
              icon: 'error',
              title: 'Try Again',
              text: err,
            });
          });
      },
      onRowClick(params) {
        let url = `/api/mail/${params.row._id}/mail/detail`;
        this.$isLoading(true);

        return requestService
          .GetFetch('ccp', url)
          .then((response) => {
            if (response.status == 200) {
              response.text().then((text) => {
                let self = this;
                self.attachments = [];
                const data = text && JSON.parse(text);
                if (data.data != null) {
                  this.$isLoading(false);

                  // console.log("data.data",data.data.body)
                  if (data.data.attachments != null) {
                    data.data.attachments.forEach((element) => {
                      element.from = 'inbound';
                      element.mail_id = data.data.mail_id;
                    });
                    self.attachments = data.data.attachments;
                  }
                  self.modalData.tracking_id = data.data.detail.tracking_id;
                  self.modalData.type = data.data.detail.mail_type;
                  self.modalData.mail_status = data.data.detail.status;
                  self.modalData.subject = data.data.detail.subject;
                  self.modalData.case_no = data.data.detail.case_no
                  self.modalData.user_name = data.data.detail.user_name
                  self.mail = data.data.body;
                  self.modalForm[0].value = self
                    .$moment(params.row.created_at)
                    .format('l LT');
                  let arr = [];
                  arr.push(data.data.detail.from);
                  self.modalForm[1].tags = arr;
                  let to = [];
                  if (data.data.detail.to_recipients.length > 0) {
                    data.data.detail.to_recipients.forEach((element) => {
                      to.push(element);
                    });
                  }
                  let cc = [];
                  if (data.data.detail.cc_recipients.length > 0) {
                    data.data.detail.cc_recipients.forEach((element) => {
                      cc.push(element);
                    });
                  }
                  let bcc = [];
                  if (data.data.detail.bcc_recipients.length > 0) {
                    data.data.detail.bcc_recipients.forEach((element) => {
                      bcc.push(element);
                    });
                  }
                  self.modalForm[2].tags = to;
                  self.modalForm[3].tags = cc;
                  self.modalForm[4].tags = bcc;
                  self.show = true;
                }
              });
            }
          })
          .catch((error) => {
            this.$notify({ text: error, type: 'danger' });
          });
      },
      loadItems(event) {
        var str = '';
        if (event != undefined) {
          for (var key in event.params) {
            if (str != '') {
              str += '&';
            }
            str += key + '=' + encodeURIComponent(event.params[key]);
          }
          this.columns.forEach((element) => {
            if (event.sortField == element.field) {
              if (
                event.sortField == 'created_at' ||
                event.sortField == 'updated_at'
              ) {
                str += '&' + 'sortField=' + event.sortField;
              } else {
                str += '&' + 'sortField=' + element.field;
              }
            }
          });
          if (event.filter != undefined) {
            for (var key in event.filter) {
              if (str != '') {
                str += '&';
              }
              str += key + '=' + encodeURIComponent(event.filter[key]);
            }
          }
        } else {
          let filter = { type: 'tracking_id', day: 90, search: '' };
          this.$refs.refDataTable.setFilter(filter);
          for (var key in filter) {
            if (str != '') {
              str += '&';
            }
            str += key + '=' + encodeURIComponent(filter[key]);
          }
          str += '&sortField=created_at&sortType=desc';
        }
        var url = '/api/mail/history/filter?' + str;
        return requestService
          .GetFetch('ccp', url)
          .then((response) => {
            if (response.status == 200) {
              response.text().then((text) => {
                let self = this;
                self.rows = [];
                const data = text && JSON.parse(text);
                if (data.data.data != null) {
                  self.json_data = data.data.data;
                  data.data.data.forEach((element) => {
                    if (
                      element.create_by != null &&
                      element.create_by != undefined
                    ) {
                      let name = element.create_by.split(':');
                      if (name.length > 1) {
                        element.create_by = name[0] + ' ' + name[1];
                      } else {
                        element.create_by = name[0];
                      }
                    }
                  });
                  self.rows = data.data.data;
                  self.$refs.refDataTable.setTotalRecords(data.data.total);
                  self.$refs.refDataTable.setPages(data.data.current_page);
                } else {
                  self.$refs.refDataTable.setTotalRecords(0);
                  self.$refs.refDataTable.setPages(1);
                }
              });
            }
          })
          .catch((error) => {
            this.$notify({ text: error, type: 'danger' });
          });
      },
    },
  };
</script>

<style>
  img {
    max-width: 100% !important;
    height: 100% !important;
  }
</style>
